module.exports = __webpack_public_path__ + "static/img/applet_pro.c2e5c609.png";